import "core-js/modules/es.array.push.js";
import { ElTable as Table } from 'element-plus';
import elementResizeDetectorMaker from 'element-resize-detector';
import columnItem from './columnItem';
import tableBtns from './tableBtns';
const defaultOptions = {
  multiSelect: false,
  expand: false,
  snIndex: false,
  loading: false,
  // 表格动画
  border: false,
  size: 'small',
  headerCellStyle: {
    background: '#f5f7fa'
  },
  highlightCurrentRow: true,
  cachePageSelection: true
};
export default {
  name: 'DpTable',
  components: {
    columnItem,
    tableBtns
    // 'RenderDom': {
    //   'functional': true, // 函数式组件 - 无 data 和 this 上下文 => better render
    //   'props': {
    //     'row': Object,
    //     'index': Number,
    //     'render': Function
    //   },
    //   /**
    //    * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
    //    * @param {Object} ctx - 渲染的节点的this对象
    //    * @argument 传递参数 row index
    //    */
    //   render (createElement, ctx) {
    //     const { row, index } = ctx.props
    //     return ctx.props.render(row, index)
    //   }
    // }
  },
  // 属性
  props: {
    ...Table.props,
    headBarClass: {
      type: [String, Object],
      default: ''
    },
    // eslint-disable-next-line vue/require-prop-types
    inject: {
      getVisibleShow: {
        default: false
      }
    },
    showHeaderBar: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    dataSource: {
      type: Array,
      default: function (val) {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // heightType: {
    //   type: String,
    //   default: function () {
    //     return 'height'
    //   }
    // },
    options: {
      type: Object,
      default: () => {
        return defaultOptions;
      }
    },
    pagination: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      erdform: null,
      tabElement: null,
      observeresize: null,
      tableId: 'table_' + parseInt(Math.random() * 1e10),
      tableContainer: 'tab_contaniner_' + parseInt(Math.random() * 1e10),
      erd: null,
      tableHeight: 400,
      ispaginstion: false,
      slotState: false,
      timer: null,
      multipleSelection: [],
      // 当前选中的所有数据
      selectionsByPage: {},
      // 按分页缓存每一页的选择的数据，注意在翻页时数据变化导致的问题，如原第一页的数据由于总数据变化变为了第二页的数据，如若不特殊处理，则导致选择的数据有重复的问题，需要设置唯一键值rowkey
      isInitChange: false,
      // 标志是否由数据变化导致的选项清空
      onpagination: Object.assign({}, {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizes: []
      }, this.pagination)
    };
  },
  computed: {
    heightType() {
      if (this.options.heightType && typeof this.options.heightType === "string") {
        return this.options.heightType;
      }
      return 'max-height';
    },
    showVisible() {
      if (typeof this.getVisibleShow === 'function') {
        return this.getVisibleShow();
      }
      return this.getVisibleShow;
    },
    tabHeight() {
      if (this.attrs.tabHeight && typeof this.attrs.tabHeight === 'number') {
        return this.attrs.tabHeight + 'px';
      }
      return '100%';
    },
    slotSyles() {
      if (this.headBarClass) {
        return {
          type: typeof this.headBarClass === 'string' ? 'String' : 'object',
          value: this.headBarClass
        };
      }
      return {
        type: 'String',
        value: ''
      };
    },
    columnsfilter() {
      return this.columns.filter(item => !item.hidCol);
    },
    attrs() {
      const heightObject = {};
      // const { options, dataSource, columns, pagination, ...attrs } = this.$props
      // console.log('this.$props////', this.$props.onSelectionChange)
      const {
        align,
        ...attr
      } = this.columnbindAttr(Object.assign({}, defaultOptions, this.$attrs, this.options, heightObject));
      return attr;
    },
    layout() {
      const result = ['total', 'prev', 'pager', 'next', 'jumper'];
      if (this.onpagination.pageSizes.length) {
        // result.unshift('sizes')
        // 将页容量调整到倒数第二位置
        result.splice(result.length - 1, 0, 'sizes');
      }
      return result.join(',');
    }
    /* paginations () {
        if (this.pagination.total) {
          return Object.assign({
            'pageSize': 10,
            'current': 1,
            'total': 0
          }, this.pagination)
        } else {
          return Object.assign({
            'pageSize': 10,
            'current': 1,
            'total': 0
          }, this.pagination)
        }
      } */
  },
  watch: {
    showVisible(val, oldval) {
      if (val) {
        this.$refs[this.tableId].doLayout();
      }
    },
    pagination: {
      handler(val, oldval) {
        this.onpagination = Object.assign({}, this.onpagination, val);
        if (val && val.total !== undefined) {
          this.ispaginstion = true;
        }
      },
      deep: true,
      immediate: true
    },
    // 监听数据变化，默认触发选中数据
    dataSource(val) {
      this.isInitChange = true;
      if (this.options.cachePageSelection) {
        this.$nextTick(() => {
          this.handleSelectData(val);
          this.isInitChange = false;
        });
      } else {
        this.clearSelection();
        this.isInitChange = false;
      }
    }
  },
  mounted() {
    this.elementResize();
    this.headerBarResize();
    this.$refs[this.tableId].doLayout();
  },
  created() {
    for (let c in Table.methods) {
      // 拷贝继承table方法到父组件
      this[c] = function (...params) {
        this.$refs[this.tableId][c](...params);
      }.bind(this);
    }
  },
  beforeUnmount() {
    this.erd.removeListener(this.$refs[this.tableContainer], this.resizeObservers);
    if (this.erdform) {
      this.erdform.removeListener(this.$refs.headBar, this.resizeBar);
    }
    if (this.observeresize) {
      this.observeresize.cancel();
    }
  },
  unmounted() {},
  updated() {
    this.$refs[this.tableId].doLayout();
  },
  activated() {
    this.elementResize();
    this.headerBarResize();
  },
  deactivated() {
    this.erd.removeListener(this.$refs[this.tableContainer], this.resizeObservers);
    if (this.erdform) {
      this.erdform.removeListener(this.$refs.headBar, this.resizeBar);
    }
    if (this.observeresize) {
      this.observeresize.cancel();
    }
  },
  methods: {
    resizeObservers(element) {
      if (!this.observeresize) {
        this.observeresize = this.throttle(this.resize, 300, {
          leading: false,
          trailing: true
        });
      }
      this.observeresize.call(this, element);
    },
    // 触发选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs[this.tableId].toggleRowSelection(row);
        });
      } else {
        this.$refs[this.tableId].clearSelection();
      }
    },
    // 清空选项
    clearAllSelection() {
      this.multipleSelection = [];
      this.selectionsByPage = {};
      this.$refs[this.tableId].clearSelection();
    },
    // 选项发生变化事件
    handleSelectionChange(val) {
      // 配置了缓存每页的选择项，即翻页不清除上一页的选择项
      if (this.options.cachePageSelection) {
        if (this.isInitChange) {
          return;
        }
        this.selectionsByPage[this.onpagination.current] = val;
        // 缓存当前所有的选择项数据
        let multipleSelection = [];
        Object.keys(this.selectionsByPage).map(page => {
          const pageSelections = this.selectionsByPage[page] || [];
          const {
            rowkey
          } = this.options;
          // 如果设置了rowkey，则判断去重，否则直接暴力合并所有分页的选择项，因为组件无法根据rowkey确认唯一性
          if (rowkey) {
            const onlyKeyMap = {};
            pageSelections.map(item => {
              if (!onlyKeyMap[item[rowkey]]) {
                multipleSelection.push(item);
                onlyKeyMap[item[rowkey]] = item;
              }
              return item;
            });
          } else {
            multipleSelection = multipleSelection.concat(pageSelections);
          }
          return page;
        });
        this.multipleSelection = multipleSelection;
      } else {
        this.multipleSelection = val;
      }
    },
    // 处理默认选中项
    handleSelectData(dataList) {
      const {
        cachePageSelection,
        rowkey
      } = this.options;
      // 需要缓存分页选择且存在必要参数rowkey和存在已选择项，则进行判断当前数据有无在选择列表中
      if (dataList?.length && cachePageSelection && rowkey && this.multipleSelection.length) {
        const pageSelecteds = [];
        dataList.map(row => {
          this.multipleSelection.map(selectedRow => {
            if (row[rowkey] === selectedRow[rowkey]) {
              pageSelecteds.push(row);
            }
          });
        });
        this.toggleSelection(pageSelecteds);
      }
    },
    refsInstance() {
      return this.$refs[this.tableId];
    },
    throttle: function (fn, interval, options = {
      leading: true,
      trailing: false
    }) {
      // 1.记录上一次的开始时间
      const {
        leading,
        trailing,
        resultCallback
      } = options;
      let lastTime = 0;
      let timer = null;

      // 2.事件触发时, 真正执行的函数
      const _throttle = function (...args) {
        return new Promise((resolve, reject) => {
          // 2.1.获取当前事件触发时的时间
          const nowTime = new Date().getTime();
          if (!lastTime && !leading) lastTime = nowTime;

          // 2.2.使用当前触发的时间和之前的时间间隔以及上一次开始的时间, 计算出还剩余多长事件需要去触发函数
          const remainTime = interval - (nowTime - lastTime);
          if (remainTime <= 0) {
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }

            // 2.3.真正触发函数
            const result = fn.apply(this, args);
            resolve(result);
            // 2.4.保留上次触发的时间
            lastTime = nowTime;
            return;
          }
          if (trailing && !timer) {
            timer = setTimeout(() => {
              timer = null;
              lastTime = !leading ? 0 : new Date().getTime();
              const result = fn.apply(this, args);
              resolve(result);
            }, remainTime);
          }
        });
      };
      _throttle.cancel = function () {
        if (timer) clearTimeout(timer);
        timer = null;
        lastTime = 0;
      };
      return _throttle;
    },
    resizeBar(e) {
      if (this.tabElement) {
        this.resize(this.tabElement);
      }
    },
    headerBarResize() {
      // 表单区域尺寸发生改变，重新计算表格高度
      this.erdform = elementResizeDetectorMaker();
      this.erdform.listenTo(this.$refs.headBar, this.resizeBar);
    },
    elementResize() {
      this.$nextTick(() => {
        this.erd = elementResizeDetectorMaker();
        this.erd.listenTo(this.$refs[this.tableContainer], this.resizeObservers);
      });
    },
    resize(element) {
      if (!element) {
        return;
      }
      this.tabElement = element;
      const tabContainer = element.offsetHeight;
      const paginationHeight = this.$refs.pagination ? this.$refs.pagination.offsetHeight : 0;
      if (this.$refs.headBar) {
        const headBar = (ele => {
          const headbarAttr = {
            headBarHeight: 0,
            slotState: false
          };
          if (ele && ele.offsetHeight > 0) {
            headbarAttr.slotState = true;
          }
          headbarAttr.headBarHeight = ele.offsetHeight;
          return headbarAttr;
        })(this.$refs.headBar);
        this.slotState = headBar.slotState;
        const tbBtnHeight = this.$refs?.tbBtn?.$el?.offsetHeight || 0;
        const tbMaxHeight = Math.floor(tabContainer) - Math.round(paginationHeight + headBar.headBarHeight + tbBtnHeight + 0); // `calc(100% - ${paginationHeight}px)`
        this.tableHeight = tbMaxHeight;
      }
    },
    firstWordUpperCase(str) {
      return str.toLowerCase().replace(/(\s|^)[a-z]/g, function (char) {
        return char.toUpperCase();
      });
    },
    columnbindAttr(cols) {
      let options = {};
      for (let t in cols) {
        if (t === 'groups' || t === 'scopedSlots' || t === 'render') {
          continue;
        } else if (t.includes('-')) {
          let newkey = '';
          let key = t.split('-');
          for (let j = 0; j < key.length; j++) {
            if (j !== 0) {
              newkey += this.firstWordUpperCase(key[j]);
            } else {
              newkey += key[j];
            }
          }
          options[newkey] = cols[t];
        } else if (t === 'key') {
          options.prop = cols[t];
          options[t] = cols[t];
        } else {
          options[t] = cols[t];
        }
      }
      if (!options.align) {
        options.align = 'center';
      }
      return options;
    },
    handleSizeChange(size) {
      this.onpagination.pageSize = size || 10;
      this.onpagination.current = 1;
      this.$emit('update:pagination', this.onpagination);
      this.$emit('size-change', this.onpagination, size);
    },
    handleIndexChange(val) {
      this.$emit('update:pagination', this.onpagination);
      this.$emit('pagination-current-change', this.onpagination);
    },
    changeTableSort(column) {
      this.$emit('change-table-sort', column);
    }
  }
};